<template>
  <v-row style="overflow: auto">
    <v-col md="6" lg="6" xl="4" class="user-block">
      <v-card flat ref="form" class="mt-0">
        <v-card-text class="pa-0 mb-4">
          <v-row>
            <v-col cols="12" class="user-topbar mb-2">
              <h2 class="step_title primary--text font-weight-light mr-3 text-uppercase">Identité 1</h2>
              <v-btn rounded small class="ma-2 btn-edit-group" outlined color="#47266F">
                <v-icon v-text="'$edit'" color="#47266F" class="mr-1"></v-icon>Edit
              </v-btn>
              <v-spacer />
              <!-- <v-checkbox v-model="checkbox" class="primary--text" :label="$t('Make default')"></v-checkbox> -->
            </v-col>

            <v-col cols="6" class="py-0">
              <p class="label">Logo de gauche</p>
              <ImagePickerInput></ImagePickerInput>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="pa-0 mb-4">
          <v-row>
            <v-col cols="6" class="py-0">
              <p class="label">Nom de la société</p>
              <v-text-field placeholder hide-details="auto" outlined required></v-text-field>
            </v-col>

            <v-col cols="6" class="py-0">
              <p class="label">Adresse</p>
              <v-text-field placeholder hide-details="auto" outlined required></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="pa-0 mb-4">
          <v-row>
            <v-col cols="6" class="py-0">
              <p class="label">Nom du contact</p>
              <v-text-field placeholder="Giao Nguyen" hide-details="auto" outlined required></v-text-field>
            </v-col>

            <v-col cols="6" class="py-0">
              <p class="label">Code postal</p>
              <v-text-field placeholder="Florian" hide-details="auto" outlined required></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="pa-0 mb-4">
          <v-row>
            <v-col cols="6" class="py-0">
              <p class="label">Email</p>
              <v-text-field
                placeholder="giao.nguyen@silkwires.com"
                hide-details="auto"
                outlined
                required
              ></v-text-field>
            </v-col>

            <v-col cols="6" class="py-0">
              <p class="label">Ville</p>
              <v-text-field placeholder="Ho Chi Minh" hide-details="auto" outlined required></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="pa-0 mb-4">
          <v-row>
            <v-col cols="6" class="py-0">
              <p class="label">Téléphone</p>
              <v-text-field placeholder="0123xxxxxx" hide-details="auto" outlined required></v-text-field>
            </v-col>

            <v-col cols="6" class="py-0">
              <p class="label">Pays</p>
              <v-autocomplete placeholder="Select..." outlined hide-details="auto"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="pa-0 mb-4">
          <v-row>
            <v-col cols="12" class="py-0">
              <p class="label">Footer</p>
              <v-textarea outlined no-resize rows="5" :value="value"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="text-center">
        <v-btn class="ma-2" depressed rounded color="primary">Enregistrer</v-btn>
        <v-btn class="ma-2 black--text" depressed rounded color="#E1E1E1">Annuler</v-btn>
      </div>
      <v-btn class="btn-add-group text-center" rounded outlined color="#47266F">
        <v-icon block v-text="'$plus_square'" color="#47266F" class="mb-1"></v-icon>AJOUTER
      </v-btn>
    </v-col>
  </v-row>
</template>


<script>
import ImagePickerInput from "@/components/inputs/ImagePickerInput.vue";

export default {
  name: "UserBillingIdentity",
  components: {
    ImagePickerInput
  },
  data() {
    return {
      checkbox: true,
      value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    };
  },

  methods: {}
};
</script>
